import { OrderMethod } from '@/domain/models/Order/orderMethod';
import { getClient } from '@/lib/restClient';
import { SalesPeriodType } from '@/pages/menu-managements/items/hooks/useMenuManagementItemForm';
import { SortObject } from '@/pages/menu-managements/services/searchItem';
import { Title } from '@/pages/menu-managements/services/title';
import {
  BrandItemDelivery,
  BrandItemEatIn,
  BrandItemTakeout,
  SpecialInstructionsSetting,
} from '@/services/BrandItem';
import { MenuManagementBrandItemService } from '@/services/BrandItem/MenuManagementItemService';

export type MenuManagementBrandItemCreateParams = {
  associate_brand_id: number;
  title: Title;
  image_url: string | null;
  memo: string | null;
  description: string | null;
  sales_start_at: string | null;
  sales_end_at: string | null;
  takeout: BrandItemTakeout | null;
  delivery: BrandItemDelivery | null;
  eat_in: BrandItemEatIn | null;
  order_methods: OrderMethod[];
  can_serve_alone: boolean;
  brand_option_group_sort_objects: SortObject[];
  is_auth_required: boolean;
  sales_period_type: SalesPeriodType;
  limit_of_purchase: number | null;
  relative_sales_start_at: number | null;
  relative_sales_end_at: number | null;
  special_instructions_setting: SpecialInstructionsSetting | null;
};

export const useMenuManagementCreateBrandItem = async (
  params: MenuManagementBrandItemCreateParams
): Promise<void> => {
  const menuManagementBrandItemService = new MenuManagementBrandItemService(
    getClient()
  );
  return await menuManagementBrandItemService.create(params);
};
